<template>
  <footer class="main-footer">
    <strong>Copyright &copy; {{ year }}
    <a href="javascript:;">Sinarmas Land</a>.</strong> All rights reserved.
    <img src="/static/img/logoSML.png" alt="" style="float:right;height:30px;">   
  </footer>
</template>

<script>
export default {
  name: 'DashFooter',
  data: function () {
    return {
      year: '2019'// new Date().getFullYear()
    }
  }
}
</script>



// WEBPACK FOOTER //
// DashFooter.vue?000079b4